module.exports = __webpack_public_path__ + "static/media/sa2.3ce5f3dc.jpg";